// extracted by mini-css-extract-plugin
module.exports = {"button":"Addons_button__2G-be","checkbox":"Addons_checkbox__2OVPX","checkboxLabel":"Addons_checkboxLabel__2w1By"};